import { BankOutlined, UserOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Alert, Typography, Button, Checkbox, Row, Col } from "antd";
import Divider from "antd/lib/divider";
import { message } from "components/Messages/Messages";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import ResetPassword from "./ResetPassword/ResetPassword";

const { Title } = Typography;

interface Props {
  text: string;
  type: "default" | "primary";
  onClick?: () => void;
}

const LoginComponent: React.FC<Props> = ({ text, type, onClick }) => {
  const [open, setOpen] = useState<boolean | undefined>(false);
  const [form] = Form.useForm();
  const { logIn } = useLoginContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [createNewUser, setCreateNewUser] = useState<boolean>(false);
  const [showResetPassword, setShowResetPassword] = useState<boolean>(false);

  const handleClickForgotPassword = () => {
    setShowResetPassword(true);
  };

  const handleCancel = () => {
    setOpen(false);
    setCreateNewUser(false);
    setError("");
    setShowResetPassword(false); // Ensure ResetPassword is hidden when modal is closed
  };

  const submit = () => {
    form.validateFields().then(values => {
      setLoading(true);
      logIn(values)
        .then(() => message("success", "Du er logget inn"))
        .catch(err => {
          if (err.response && err.response.data) {
            setError(String(err.response.data.detail));
          }
          setLoading(false);
        });
    });
  };

  return (
    <>
      <Button
        type={type}
        block
        onClick={() => {
          setOpen(true);
          if (onClick) onClick();
        }}
      >
        {text}
      </Button>
      <Modal open={open} footer={null} onCancel={handleCancel}>
        {showResetPassword ? (
          <ResetPassword handleClose={handleCancel} />
        ) : createNewUser ? (
          <Row>
            <Col span={24}>
              <Title level={4} style={{ marginBottom: "20px" }}>
                Opprett ny bruker
              </Title>
            </Col>
            <Col span={12}>
              <Link to="/create-student-profile/">
                <Button
                  type="text"
                  icon={<UserOutlined />}
                  onClick={() => {
                    setOpen(false);
                    setCreateNewUser(false);
                  }}
                  style={{ fontSize: "5em", width: "100%", height: "300px" }}
                >
                  <Title level={4}>Student</Title>
                </Button>
              </Link>
            </Col>
            <Col span={12}>
              <Link to="/create-company-profile/">
                <Button
                  type="text"
                  icon={<BankOutlined />}
                  onClick={() => {
                    setOpen(false);
                    setCreateNewUser(false);
                  }}
                  style={{ fontSize: "5em", width: "100%", height: "300px" }}
                >
                  <Title level={4}>Bedrift</Title>
                </Button>
              </Link>
            </Col>
          </Row>
        ) : (
          <>
            <Title level={4} style={{ marginBottom: "20px" }}>
              Velkommen!
            </Title>
            <Form form={form} labelCol={{ span: 6 }} name="login" initialValues={{ modifier: "public" }}>
              <Form.Item
                name="username"
                normalize={(value: string) => (value ? value.toLowerCase() : "")}
                rules={[{ required: true, message: "Vennligst skriv inn brukernavn eller e-post" }]}
              >
                <Input size="large" placeholder="Brukernavn" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Vennligst skriv inn passord!" }]}
                style={{ marginBottom: "22px" }}
              >
                <Input.Password size="large" placeholder="Passord" />
              </Form.Item>
              <Row style={{ justifyContent: "space-between" }}>
                <Form.Item style={{ marginBottom: "10px" }}>
                  <Checkbox>Husk meg</Checkbox> {/* TODO make remember me functionality  */}
                </Form.Item>
                <Form.Item style={{ marginBottom: "10px" }}>
                  <Button type="text" onClick={handleClickForgotPassword}>
                    Glemt passord?
                  </Button>
                </Form.Item>
              </Row>
              {error && <Alert message={error} type="error" style={{ color: "var(--dark)" }} />}
              <Col style={{ height: "40px", width: "100%", marginTop: "15px" }}>
                <Form.Item>
                  <Button type="primary" block size="large" htmlType="submit" onClick={submit}>
                    {loading ? "Logger inn..." : "Logg inn"}
                  </Button>
                </Form.Item>
              </Col>
              <Divider />
              <Col>
                <Button block type="text" onClick={() => setCreateNewUser(true)} style={{ color: "grey" }}>
                  Opprett ny student eller bedriftsbruker
                </Button>
              </Col>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
};

export default LoginComponent;
